import { render } from "./PopupVacancy.vue?vue&type=template&id=1af3a9a8"
import script from "./PopupVacancy.vue?vue&type=script&lang=js"
export * from "./PopupVacancy.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/fl-dev.xpage.dev/htdocs/web/local/templates/.default/vue-fianit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__